import axios from 'axios';
import envs from 'config/envs';
import Cookies from 'js-cookie';

import jwt from 'jsonwebtoken';

import { makeAutoObservable } from 'mobx';
import { createContext } from 'react';

export class TokenManager {
  public token?: string;

  private tokenKey = 'starfarm:token';

  private tokenDomain = {
    path: '',
    domain: process.env.REACT_APP_COOKIES_DOMAIN,
  };

  constructor() {
    makeAutoObservable(this);
  }

  public setToken(token?: string) {
    this.token = token;
  }

  public get isExpired() {
    if (!this.decodedToken) {
      return true;
    }

    return Date.now() >= this.decodedToken.exp * 1000;
  }

  public get decodedToken() {
    const token = this.token;

    if (!token) {
      return undefined;
    }

    const decoded = jwt.decode(token) as any;

    return decoded as Token;
  }

  public get isBeneficiary() {
    if (!this.decodedToken) {
      return false;
    }

    return this.decodedToken.isBeneficiary;
  }

  public get axiosClient() {
    return axios.create({
      baseURL: envs.apiBaseUrl,
      headers: {
        Authorization: this.token,
      },
    });
  }

  public clearToken() {
    try {
      Cookies.remove(this.tokenKey, this.tokenDomain);

      this.token = undefined;

      return true;
    } catch (error) {
      console.error(error);

      return false;
    }
  }

  public storeToken(sessionToken: string) {
    try {
      this.token = sessionToken;
      Cookies.set(this.tokenKey, sessionToken, this.tokenDomain);

      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  public getToken(): string | undefined {
    try {
      return Cookies.get(this.tokenKey);
    } catch (error) {
      console.error('Error getting token:', error);
      return undefined;
    }
  }
}

export const TokenManagerStore = new TokenManager();

const TokenManagerContext = createContext(TokenManagerStore);

export default TokenManagerContext;
